// extracted by mini-css-extract-plugin
module.exports = {"checkboxContainer":"StepTwo_checkboxContainer__31Z5-","nextStepButton":"StepTwo_nextStepButton__1SI9K","termsOfWebsiteContainer":"StepTwo_termsOfWebsiteContainer__3arAU"};